module.exports = __webpack_public_path__ + "static/media/2. Formaciones, Mixta en tela, 90 x 190 cm, 2018 copy.d8d79625.png";